
import {computed, ComputedRef, defineComponent} from "vue";
import {useStore} from "vuex";
import {finishQuestionnaire, questionErrorHandler, redirectToQuestionnaireCover} from "./questionnaire_error_handler";
import {useRoute} from "vue-router";

export default defineComponent({
  name: "QuestionnaireFooter",
  setup() {
    const store = useStore();
    const route = useRoute();

    const hasPrevious: ComputedRef<boolean> = computed(
        () => store.getters["content_module/questionnaire/questionnaire_control/hasPrevious"]);

    const hasNext: ComputedRef<boolean> = computed(
        () => store.getters["content_module/questionnaire/questionnaire_control/hasNext"]);

    const onClickPrevious = async (): Promise<void> => {
      try {
        await loadPreviousQuestion();
      } catch (e) {
        console.error("[onClickPrevious] Error ", e);
        await questionErrorHandler(e);
      }
    };

    const loadPreviousQuestion = async (): Promise<void> => {
      try {
        await store.dispatch("content_module/questionnaire/questionnaire_control/loadPrevious");
      } catch (e) {
        console.error("[onClickPrevious] Error loadPreviousContent ", e);
        throw e;
      }
    };

    const onClickNext = async (): Promise<void> => {
      try {
        await loadNextQuestion();
      } catch (e) {
        console.error("[onClickNext] Error ", e);
        await questionErrorHandler(e);
      }
    };

    const loadNextQuestion = async (): Promise<void> => {
      try {
        await store.dispatch("content_module/questionnaire/questionnaire_control/loadNext");
      } catch (e) {
        console.error("[loadNextQuestion] Error ", e);
        throw e;
      }
    };

    const onClickFinish = async (): Promise<void> => {
      try {
        await finishQuestionnaire();
        await redirectToQuestionnaireCover();
        await reloadContent();
        await reloadContentList();
      } catch (e) {
        console.error("[onClickFinish] Error ", e);
        await questionErrorHandler(e);
      }
    };

    /** This serves to update the result on the QuestionnaireCover view.
     * TODO: Find a better way to do that. */
    const reloadContent = async (): Promise<void> => {
      try {
        await store.dispatch("content_module/setCurrentContent", route.params.content_id);
      } catch (e) {
        console.error("[setCurrentContent] Error dispatch ", e);
        throw e;
      }
    };

    /** This serves to update the content listing .
     * TODO: Find a better way to do that. */
    const reloadContentList = async (): Promise<void> => {
      try {
        await store.dispatch("content_module/loadAllContents");
      } catch (e) {
        console.error("[reloadContentList] Error dispatch ", e);
        throw e;
      }
    };

    return {
      hasPrevious,
      hasNext,
      onClickPrevious,
      onClickFinish,
      onClickNext,
    }
  }
})
